const projectModules = require.context(".", false, /^(?!\.\/index\.js$).*\.js$/);

const projects = projectModules
  .keys()
  .map((modulePath) => projectModules(modulePath).projectEntry)
  .filter(Boolean)
  .sort((left, right) => left.name.localeCompare(right.name));

export default projects;